var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStationaryConcretePump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "30 60 210 140",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .statusFill {\n            fill: #2A6FAE;\n        }\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer12",
    transform: "matrix(10,0,0,10,-70,-70)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.16373,40,-5.97852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.86,19.603C13.941,19.189 14.358,18.886 14.846,18.886C16.383,18.886 19.617,18.886 21.154,18.886C21.642,18.886 22.059,19.189 22.14,19.603C22.415,21.011 23,24 23,24L13,24C13,24 13.585,21.011 13.86,19.603Z",
    className: "statusFill"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,42,-2.04892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5,25L24.5,24.5C24.5,24.5 13.414,24.5 13.414,24.5C13.212,24.5 13.03,24.622 12.952,24.809C12.875,24.995 12.918,25.211 13.061,25.354L14.061,26.354C14.154,26.447 14.282,26.5 14.414,26.5L28.382,26.5C28.571,26.5 28.744,26.393 28.829,26.224L30.274,23.334C30.274,23.334 27.5,22.64 27.5,22.64C27.5,22.64 27.5,25 27.5,25C27.5,25.276 27.276,25.5 27,25.5C26.724,25.5 26.5,25.276 26.5,25L26.5,22C26.5,21.846 26.571,21.701 26.692,21.606C26.814,21.511 26.972,21.478 27.121,21.515L31.121,22.515C31.268,22.552 31.391,22.653 31.454,22.791C31.518,22.929 31.515,23.088 31.447,23.224C31.447,23.224 30.272,25.573 29.724,26.671C29.47,27.179 28.95,27.5 28.382,27.5L14.414,27.5C14.016,27.5 13.635,27.342 13.354,27.061C13.11,26.817 12.741,26.448 12.354,26.061C11.925,25.632 11.796,24.986 12.028,24.426C12.261,23.865 12.808,23.5 13.414,23.5C17.419,23.5 25,23.5 25,23.5C25.276,23.5 25.5,23.724 25.5,24L25.5,25C25.5,25.276 25.276,25.5 25,25.5C24.724,25.5 24.5,25.276 24.5,25Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.537007,0,0,0.537007,27.6661,10.7723)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.207,
    cy: 26.403,
    r: 2.793,
    className: "statusFill"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.03,16.501L24,16.5C23.172,16.5 22.5,17.172 22.5,18L22.5,19C22.5,19.276 22.724,19.5 23,19.5C23.276,19.5 23.5,19.276 23.5,19L23.5,18C23.5,17.724 23.724,17.5 24,17.5C24,17.5 24,17.5 24,17.5L24.027,17.457C24.144,17.269 24.567,16.527 24.03,16.501Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,45.5,-1.77446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5,20L21.5,21C21.5,21.276 21.276,21.5 21,21.5C20.724,21.5 20.5,21.276 20.5,21L20.5,20C20.5,19.724 20.724,19.5 21,19.5C21.276,19.5 21.5,19.724 21.5,20Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,43.5,-1.77446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5,20L21.5,21C21.5,21.276 21.276,21.5 21,21.5C20.724,21.5 20.5,21.276 20.5,21L20.5,20C20.5,19.724 20.724,19.5 21,19.5C21.276,19.5 21.5,19.724 21.5,20Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,41.5,-1.77446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5,20L21.5,21C21.5,21.276 21.276,21.5 21,21.5C20.724,21.5 20.5,21.276 20.5,21L20.5,20C20.5,19.724 20.724,19.5 21,19.5C21.276,19.5 21.5,19.724 21.5,20Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.537007,0,0,0.537007,27.6661,10.7723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.207,22.679C17.262,22.679 18.931,24.348 18.931,26.403C18.931,28.459 17.262,30.128 15.207,30.128C13.151,30.128 11.482,28.459 11.482,26.403C11.482,24.348 13.151,22.679 15.207,22.679ZM15.207,24.541C14.179,24.541 13.345,25.376 13.345,26.403C13.345,27.431 14.179,28.266 15.207,28.266C16.235,28.266 17.069,27.431 17.069,26.403C17.069,25.376 16.235,24.541 15.207,24.541Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStationaryConcretePump);
export default __webpack_public_path__ + "static/media/stationaryConcretePump.af30b19ab413d820dfde557ac7285aeb.svg";
export { ForwardRef as ReactComponent };